module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="control-header"><h5>'+
((__t=( i18n.tc( "LogLayout", "Log:" ) ))==null?'':__t)+
' '+
((__t=( logTitle ))==null?'':__t)+
'</h5><div class="button-container pos-top-right"> ';
 if ( context !== "user" ) { 
__p+=' <a href="#" class="icon icon-material icon-circle-plus" data-click="log-create"><span class="screen-reader-text">'+
((__t=( i18n.tc( "LogLayout", "New log entry") ))==null?'':__t)+
'</span></a> ';
 } 
__p+=' <a href="#" class="icon icon-material icon-log" data-click="log-tags"><span class="screen-reader-text">'+
((__t=( i18n.tc( "LogLayout", "Filter log tags") ))==null?'':__t)+
'</span></a></div></div> ';
 if ( context !== "user" ) { 
__p+=' <div data-region="log-create"></div> ';
 } 
__p+=' <div class="block"><div data-region="log-tags"></div><div class="pagination-strip btns-9 clearfix" data-element="pagination-strip" data-input="pagination-strip"><nav aria-label="Pagination"><ul data-container="pagination-strip"></ul></nav></div></div><div data-region="log-container"></div>';
}
return __p;
};
